import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { CompanyDetails } from "./CompanyDetails";

const CompanyManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <CompanyDetails />} />
    
  </Switch>
);

export const CompanyManagement = withRouter(CompanyManagementRoutes);